import { render, staticRenderFns } from "./BusinessScopeTrack.vue?vue&type=template&id=23e2ba43&"
import script from "./BusinessScopeTrack.vue?vue&type=script&lang=js&"
export * from "./BusinessScopeTrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports